<page-content>
  <page-content-header>
    <breadcrumb>
      <span class="title">
        {{'INVITES'|translate}}
      </span>
      <span class="link1">
        <a routerLink="/">
          <i class="fas fa-home"></i> {{'HOME'|translate}}</a>
      </span>
      <span class="link2">
        <a routerLink="/invites" onClick="return false;">{{'INVITES'|translate}}</a>
      </span>
      <span class="active">
        {{'INVITES'|translate}}
      </span>
    </breadcrumb>

  </page-content-header>
  <mat-card>
    <mat-card-header>
      <h2>
        <strong>{{'INVITES'|translate}}</strong>
      </h2>
    </mat-card-header>
    <mat-card-content>
      <table-container>

        <table-container-header>
          <div class="row">
            <div class="col-4">
              <ul class="header-buttons">
                <li>
                  <div class="icon-button-demo">
                    <button mat-icon-button color="basic" class="btn-tbl-refresh" (click)="onRefresh()">
                      <mat-icon class="col-white">refresh
                      </mat-icon>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </table-container-header>

        <table-container-body class="spinner-content">

          <content-loader [loading]="loading$ | async"></content-loader>

          <mat-table #table [dataSource]="(dataSource$ | async).data" class="mat-cell">

            <ng-container matColumnDef="type">
              <mat-header-cell *matHeaderCellDef>{{'TYPE'|translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.type|translate}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef>{{'STATUS'|translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.status}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdAt">
              <mat-header-cell *matHeaderCellDef>{{'CREATED_DATE'|translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.createdAt|date:'dd.MM.yyyy HH:mm'}}</mat-cell>
            </ng-container>

            <!-- actions -->
            <ng-container matColumnDef="actions">
              <mat-header-cell class="pl-3 tbl-col-width-per-10" *matHeaderCellDef>{{'ACTIONS'|translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i=index;" class="pl-3 tbl-col-width-per-10">
                <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item [routerLink]="[row.id]">
                    <i class="material-icons-two-tone align-middle msr-2">create</i>
                    <span>{{'EDIT'|translate}}</span>
                  </button>
                </mat-menu>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (dblclick)="editItem(row)"
              [style.cursor]="'pointer'" matRipple>
            </mat-row>
          </mat-table>
          <div *ngIf="!(loading$ | async)" class="no-results"
            [style.display]="(dataSource$ | async).total == 0 ? '' : 'none'">
            {{ 'NO_RESULTS'|translate}}
          </div>
          <mat-paginator #paginator (page)="onChangePage()" [length]="(dataSource$ | async).total" [pageIndex]="0"
            [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
          </mat-paginator>
        </table-container-body>
      </table-container>

    </mat-card-content>
  </mat-card>
</page-content>
